define(
    'viewmodels/secured/lists/settings',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (ViewModel, dataProvider, i19n) {
        var vm = new ViewModel(
        {
            id: '',
            notify: {},
            reload: {},
            comboClick: {},
            i19n: i19n,
            name: ko.observable(''),
            description: ko.observable(''),
            codeTitle: ko.observable(''),
            descriptionTitle: ko.observable(''),
            manytomany: ko.observable()
        });

        vm.activate = function () {
        };
        vm.attached = function () {
            var kendoMulti = $("#multiMM")
                            .kendoMultiSelect({
                                dataTextField: "name",
                                dataValueField: "listId",
                                dataSource: {
                                    transport: {
                                        read: function(callbacks) {
                                            dataProvider.lists
                                                .getLists()
                                                .done(function (lists) {
                                                    lists = _.without(lists, _.findWhere(lists, { listId: vm.id }));

                                                    callbacks.success(lists);                                    
                                            });
                                        }
                                    }
                                }
                            }).data("kendoMultiSelect");

            dataProvider.lists
            .getList(vm.id)
            .done(function (result) {
                var manytomany = _.map(result.relatedListManyMany, function (data) { return data.listId; });

                vm.name(result.name);
                vm.description(result.description);
                vm.codeTitle(result.codeTitle);
                vm.descriptionTitle(result.descriptionTitle);
                vm.manytomany(manytomany);
                    
                kendoMulti.value(vm.manytomany());
            })
            .fail(function (e) {
                vm.notify(e.error);

                console.error(e);
            });
        };
        vm.saveClick = function () {
            var validator = $('#list-form-settings').kendoValidator().data('kendoValidator');

            if (validator.validate()) {
                var manytomany = [];

                manytomany = _.map(vm.manytomany(), function (data) {
                    return { listId: data };
                });

                dataProvider.lists
                .updateSettings(vm.id, vm.name(), '', vm.codeTitle(), vm.descriptionTitle(), manytomany)
                .done(function (result) {
                    vm.notify('success', i19n.to.listupdated);                    

                    //vm.reload(vm.id, false, vm.name());

                    setTimeout(function() {
                        vm.comboClick(vm.id);                        
                    }, 500);
                })
                .fail(function (e) {
                    vm.notify(e.error);

                    console.error(e);
                });
            }
        };
        vm.cancelClick = function() {
            vm.comboClick(vm.id);
        };

        return vm;
    }
);
